// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voV8vtWsjZDUDlrnaIPF{border:1px solid #ecedf5;padding:8px;width:100%;height:100%;display:flex;flex-direction:row}.voV8vtWsjZDUDlrnaIPF.LyjClSu314iO7mcne9e5{flex-direction:row-reverse;gap:10px}.CTJOdbtHpvteQwmpSLa0{flex:1}.CTJOdbtHpvteQwmpSLa0>wave{overflow:hidden !important}.RiDHDJ7qSpnEmMTvYUAp{display:flex;flex-direction:row;justify-content:space-between;margin-left:0.6666666667rem;align-items:center}.RiDHDJ7qSpnEmMTvYUAp button{display:inline-flex;align-items:center;justify-items:center;justify-content:center;color:#fff;border:none;background:#6e32f0;cursor:pointer;font-size:1.5rem;width:3.1666666667rem;height:3.1666666667rem;border-radius:50%}.RiDHDJ7qSpnEmMTvYUAp button i{color:#fff}.RiDHDJ7qSpnEmMTvYUAp button:hover i{color:#d3c1fa}.RiDHDJ7qSpnEmMTvYUAp button.dGPbRdtHpcm2vozAC8t1 i,.RiDHDJ7qSpnEmMTvYUAp button:active i{color:#131a4f}.RiDHDJ7qSpnEmMTvYUAp button:focus{outline:0}.RiDHDJ7qSpnEmMTvYUAp *+button{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"bar": `#6e32f0`,
	"barAfter": `#d0dae9`,
	"player": `voV8vtWsjZDUDlrnaIPF`,
	"reverse": `LyjClSu314iO7mcne9e5`,
	"waveform": `CTJOdbtHpvteQwmpSLa0`,
	"flexContainer": `RiDHDJ7qSpnEmMTvYUAp`,
	"active": `dGPbRdtHpcm2vozAC8t1`
};
export default ___CSS_LOADER_EXPORT___;
